import TemplateView from "../../TemplateView"
import StatusRow from "./StatusRow"
import SortableListContainer from "../../components/SortableListContainer"
import AutoScrollableWrapper from '../../taskManagement/kanban/components/AutoScrollableWrapper'
import {isArraysWithIdsItemsOrderEqual} from '../../atUtils'

export default class StatusesListContainer extends TemplateView {
    constructor({
        onPositionChangedCb = () => {},
        onStatusNameClickCb = () => {},
        onItemDeleteClickCb = () => {}
    }) {

        super(null)

        this.nodes = {}

        this.state = {
            statuses: [],
            editItemId: null
        }

        this.callbacks = {
            onPositionChangedCb,
            onStatusNameClickCb,
            onItemDeleteClickCb
        }

        this.onStatePropertyChanged('statuses', (statuses, prevStatuses) => {
            if (!isArraysWithIdsItemsOrderEqual(statuses, prevStatuses)) {
                this.sortableListContainer.setState({items: statuses})
                this.sortableStatusesListWrapper.refreshScroll()
            } else {
                this._updateStatusRowsStates(statuses)
            }
        })

        this.onAnyStatePropertyChanged(['editItemId'], () => {
            this._updateStatusRowsStates(this.state.statuses)
        })
    }

    templateHtml() {
        return '<div class="statusesList"/>'
    }

    afterRender() {
        const statusRowRenderer = (item) => {
            const node = new StatusRow({
                id: item.id,
                name: item.name,
                type: item.type,
                colorId: item.colorId,
                enabledStatus: item.enabledStatus,
                onStatusClickCb: () => this.callbacks.onStatusNameClickCb(node.getEl(), item.id),
                onDeleteClickCb: () => this.callbacks.onItemDeleteClickCb(item.id),
            })

            this.nodes[item.id] = node
            this._updateStatusRowState(item)
            return node
        }

        this.sortableListContainer = new SortableListContainer({
            itemRenderer: statusRowRenderer,
            sortableConfig: {
                axis: 'y',
                tolerance: 'pointer',
                containmentEl: '.statusesList',
                cursorAt: {top: 30},
            },
            onPositionChangedCb: ({id, itemIndex}) => {
                this.callbacks.onPositionChangedCb({
                    id: id,
                    newPosition: this.state.statuses[itemIndex].position
                })
            },
        })

        this.sortableStatusesListWrapper = new AutoScrollableWrapper({
            components: [this.sortableListContainer],
            autoScrollEnabled: true,
            enableVerticalScroll: true,
            verticalScrollConfig: {
                probeType: 2
            },
            scrollEvent: 'sortableList_itemDrag',
            eventDataRetriever: (event, mouseEvent) => mouseEvent,
        }).init(this.getEl())
    }

    _updateStatusRowsStates(statuses) {
        statuses.forEach((status) => this._updateStatusRowState(status))
    }

    _updateStatusRowState(item) {
        this.nodes[item.id].setState({
            inEdit: item.id === this.state.editItemId,
            name: item.name,
            colorId: item.colorId,
            type: item.type,
            enabledStatus: item.enabledStatus,
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/StatusesListContainer.js